var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/Check"},React.createElement("path",{"id":"Vector","d":"M25.3337 9.58325L12.5003 22.4166L6.66699 16.5833","stroke":"#BDFF3B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Check.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Check;

Check.default = Check;
